import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";
import { Skeleton } from "#shared/view/designSystem/Skeleton";

export const PartHeaderSkeleton = () => {
  return (
    <Flex gap="xs" align={"flex-start"} miw={250}>
      <Skeleton height={55} width={55} />
      <Stack miw={200} gap={"xs"}>
        <Skeleton height={24} />
        <Flex gap="xs">
          <Skeleton height={21} radius={"xl"} />
          <Skeleton height={21} radius={"xl"} />
          <Skeleton height={21} radius={"xl"} />
        </Flex>
      </Stack>
    </Flex>
  );
};
